import type { PopupDevice, PopupPage } from '~~/shared/types/store'

/**
 * Klucz sesyjny „ten popup już się auto-rozwinął w tej sesji" — wiązany z ID popupu.
 * Per-ID (nie globalnie): gdy jedna promocja wygaśnie i wskoczy druga (nowe ID),
 * nowy popup mobile/home dostaje swój jeden auto-pokaz w tej samej sesji.
 */
export function autoExpandStorageKey(id: number): string {
  return `lavmag-popup-autoexpanded-${id}`
}

/**
 * Czy panel wysuwany (collapsible) ma się auto-rozwinąć przy pojawieniu się.
 * Strona główna (desktop i mobile) — rozwiń raz na sesję.
 * Pozostałe strony (other) startują zwinięte (widoczny sam boczny pasek).
 */
export function shouldAutoExpandCollapsible(
  device: PopupDevice,
  page: PopupPage,
  alreadyExpandedThisSession: boolean,
): boolean {
  return page === 'index' && !alreadyExpandedThisSession
}
